

// import React, { useState } from 'react';
// import {
//   ChevronRight,
//   Cloud,
//   Users,
//   Settings,
//   TrendingUp,
//   Globe,
//   BarChart3,
//   Shield,
//   Zap,
//   Factory,
//   ShoppingCart,
//   Beaker,
//   Shirt,
//   Coffee,
//   Package,
//   CheckCircle,
//   ArrowRight,
//   Play,
//   Star,
//   Eye,
//   DollarSign,
//   Clock,
//   Target,
//   Gauge
// } from 'lucide-react';
// import InforAlliancePartnerLogo from '../../../../../Assets/Logo/InforAlliancePartner.png'
// import { Link,useNavigate } from 'react-router-dom';
// const InforM3Component = () => {
//   const [activeIndustry, setActiveIndustry] = useState(0);
//   const [hoveredService, setHoveredService] = useState(null);
//   const [activeBenefit, setActiveBenefit] = useState(0);

//   const navigate=useNavigate()
//    const handleClick = () => {
//      // Handle button click
//      navigate('/contact')
//      window.scrollTo(0,0)
//    }
//   const industries = [
//     {
//       title: "Food and Beverage",
//       description: "Comprehensive solutions for food production, quality control, and supply chain management with full traceability.",
//       icon: <Coffee className="w-8 h-8" />,
//       color: "#F97316", // orange-500 to #DC2626 red-600
//       bgColor: "#FFF7ED", // orange-50 to #FEF2F2 red-50
//       image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=300&fit=crop"
//     },
//     {
//       title: "Fashion and Apparel",
//       description: "Manage complex product variations, seasonal collections, and global fashion supply chains efficiently.",
//       icon: <Shirt className="w-8 h-8" />,
//       color: "#EC4899", // pink-500 to #A855F7 purple-500
//       bgColor: "#FDF2F8", // pink-50 to #FAF5FF purple-50
//       image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&h=300&fit=crop"
//     },
//     {
//       title: "Chemical and Pharmaceutical",
//       description: "Ensure compliance, batch tracking, and quality control in highly regulated chemical and pharma industries.",
//       icon: <Beaker className="w-8 h-8" />,
//       color: "#10B981", // green-500 to #14B8A6 teal-500
//       bgColor: "#F0FDF4", // green-50 to #F0FDFA teal-50
//       image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=400&h=300&fit=crop"
//     },
//     {
//       title: "Equipment and Industrial Manufacturing",
//       description: "Optimize production planning, resource management, and maintenance for industrial operations.",
//       icon: <Factory className="w-8 h-8" />,
//       color: "#3B82F6", // blue-500 to #6366F1 indigo-500
//       bgColor: "#EFF6FF", // blue-50 to #EEF2FF indigo-50
//       image: "https://images.unsplash.com/photo-1565087800248-7f042b50ea6b?w=400&h=300&fit=crop"
//     },
//     {
//       title: "Distribution and Consumer Goods",
//       description: "Streamline distribution networks, inventory management, and customer fulfillment processes.",
//       icon: <Package className="w-8 h-8" />,
//       color: "#F59E0B", // amber-500 to #F97316 orange-500
//       bgColor: "#FFFBEB", // amber-50 to #FFF7ED orange-50
//       image: "https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=400&h=300&fit=crop"
//     }
//   ];

//   const services = [
//     {
//       title: "Implementation & Project Management",
//       description: "We deliver full-cycle implementation of Infor M3, from business requirement analysis to go-live and post-launch support.",
//       icon: <Target className="w-6 h-6" />,
//       color: "#F97316" // orange-600 to #DC2626 red-600
//     },
//     {
//       title: "System Integration & Customization",
//       description: "Seamlessly integrate M3 with your existing business applications and customize features to match your workflows.",
//       icon: <Settings className="w-6 h-6" />,
//       color: "#3B82F6" // blue-500 to #6366F1 indigo-500
//     },
//     {
//       title: "Cloud Migration & Upgrades",
//       description: "Modernize your ERP by moving to Infor CloudSuite M3. We help you migrate without disrupting business operations.",
//       icon: <Cloud className="w-6 h-6" />,
//       color: "#10B981" // green-500 to #14B8A6 teal-500
//     },
//     {
//       title: "Support & Managed Services",
//       description: "Our dedicated support team ensures your system runs smoothly, with ongoing maintenance, issue resolution, and optimization.",
//       icon: <Shield className="w-6 h-6" />,
//       color: "#A855F7" // purple-500 to #EC4899 pink-500
//     },
//     {
//       title: "User Training & Change Management",
//       description: "We help your teams adopt Infor M3 through tailored training programs and user-friendly documentation.",
//       icon: <Users className="w-6 h-6" />,
//       color: "#F59E0B" // amber-500 to #F97316 orange-500
//     }
//   ];

//   const benefits = [
//     {
//       title: "Industry-Specific Functionality",
//       description: "Out-of-the-box features designed for your sector",
//       icon: <Factory className="w-8 h-8" />,
//       color: "#F97316" // orange-500 to #DC2626 red-500
//     },
//     {
//       title: "Cloud Deployment via Infor CloudSuite",
//       description: "Scalable, secure, and accessible anywhere",
//       icon: <Cloud className="w-8 h-8" />,
//       color: "#3B82F6" // blue-500 to #6366F1 indigo-500
//     },
//     {
//       title: "Multi-Company, Multi-Currency Support",
//       description: "Ideal for global and regional operations",
//       icon: <Globe className="w-8 h-8" />,
//       color: "#10B981" // green-500 to #14B8A6 teal-500
//     },
//     {
//       title: "End-to-End Visibility",
//       description: "Gain control across finance, supply chain, manufacturing, and customer service",
//       icon: <Eye className="w-8 h-8" />,
//       color: "#A855F7" // purple-500 to #EC4899 pink-500
//     },
//     {
//       title: "Real-Time Analytics",
//       description: "Make faster, smarter decisions with built-in BI tools",
//       icon: <BarChart3 className="w-8 h-8" />,
//       color: "#F59E0B" // amber-500 to #F97316 orange-500
//     },
//     {
//       title: "Improved Compliance & Traceability",
//       description: "Especially important in regulated industries like food and chemicals",
//       icon: <CheckCircle className="w-8 h-8" />,
//       color: "#14B8A6" // teal-500 to #10B981 green-500
//     },
//     {
//       title: "Faster Time-to-Value",
//       description: "Get up and running quicker with best practices built in",
//       icon: <Gauge className="w-8 h-8" />,
//       color: "#DC2626" // red-500 to #EC4899 pink-500
//     }
//   ];

//   return (
//     <div className="min-h-screen" style={{ background: 'linear-gradient(to bottom right, #FFF7ED, #FEF2F2, #FDF2F8)' }}>
//       {/* Hero Section */}
//       <section className="relative overflow-hidden" style={{ background: 'linear-gradient(to bottom right, #111827, #9A3412, #991B1B)' }}>
//         <div className="absolute inset-0" style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}></div>
//         <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(234, 88, 12, 0.2), rgba(220, 38, 38, 0.2))' }}></div>
        

       
//         <div className="relative container mx-auto px-4 py-10">
//           <div className="grid lg:grid-cols-2 gap-12 items-center">
//             <div className="space-y-8">
//               <div className="inline-flex items-center space-x-2 rounded-full px-4 py-2 border" style={{ backgroundColor: 'rgba(249, 115, 22, 0.2)', backdropFilter: 'blur(8px)', borderColor: 'rgba(251, 146, 60, 0.3)' }}>
//                 <Star className="w-4 h-4" style={{ color: '#FBBF24' }} />
//                 <span className="text-sm font-medium" style={{ color: '#FED7AA' }}>Leading Infor M3 Provider in Indonesia</span>
//               </div>
              
//               <div className="space-y-4">
//                 <h1 className="text-5xl lg:text-6xl font-bold leading-tight" style={{ color: '#FFFFFF' }}>
//                   <span className="text-3xl lg:text-4xl" style={{ color: '#E5E7EB' }}>Unlock Business Agility with</span>
//                   <br />
//                   <span
//                     className='text-3xl lg:text-4xl'
//                     style={{ background: 'linear-gradient(to right, #FB923C, #F87171)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>
//                     Infor M3
//                   </span>
//                 </h1>
                
//                 <p className="text-xl leading-relaxed max-w-2xl" style={{ color: '#D1D5DB' }}>
//                   Drive transformation, improve decision-making, and enable growth with our expert Infor M3 ERP solutions.
//                   Flexible, scalable, and along with  industry-smart systems for modern enterprises.
//                 </p>
//               </div>
              
//               <div className="flex flex-col sm:flex-row gap-4">


//                 <Link to="/contact">
//                    <button className="group px-8 py-4 rounded-xl font-semibold hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center" style={{ background: 'linear-gradient(to right, #EA580C, #DC2626)', color: '#FFFFFF', boxShadow: '0 0 50px rgba(249, 115, 22, 0.25)' }}>
//                   Start Your Transformation
//                   <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
//                 </button>
                
//                 </Link>

             
      
              
//               </div>
//             </div>
            
//             <div className="relative">
//               <div className="relative z-10">
//                 <img
//                   src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop"
//                   alt="Infor M3 Dashboard"
//                   className="rounded-2xl shadow-2xl transition-all duration-500 transform hover:scale-105"
                 
//                 />
//                 <div className="absolute inset-0 rounded-2xl" style={{ background: 'linear-gradient(to top right, rgba(234, 88, 12, 0.2), rgba(220, 38, 38, 0.2))' }}></div>
//               </div>
              
          
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Power Behind M3 Section */}
//       <section className="py-10 px-6" style={{ background: 'linear-gradient(to bottom right, #FFFFFF, #FFF7ED)' }}>
//         <div className="container mx-auto">
//           <div className="max-w-5xl mx-auto text-center mb-16">
//             <h2 className="text-3xl lg:text-4xl font-bold mb-6" style={{ color: '#111827' }}>
//               The <span className='text-3xl lg:text-4xl' style={{ background: 'linear-gradient(to right, #EA580C, #DC2626)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>Power</span> Behind Infor M3
//             </h2>
//             <p className="text-xl leading-relaxed max-w-5xl text-center" style={{ color: '#6B7280' }}>
//               Infor M3 is a powerful, cloud-enabled ERP solution designed for medium to large enterprises in complex,
//               and global industries. Built specifically for sectors like fashion, food & beverage, chemicals, and industrial
//               manufacturing, it supports multi-site, multi-language, and multi-currency operations—all within a single,
//               integrated platform.
//             </p>
//           </div>
          
//           <div className="grid md:grid-cols-3 gap-8 mb-12">
//             <div className="text-center group">
//               <div className="w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" style={{ background: 'linear-gradient(to bottom right, #F97316, #DC2626)' }}>
//                 <Globe className="w-10 h-10" style={{ color: '#FFFFFF' }} />
//               </div>
//               <h3 className="text-xl font-bold mb-2" style={{ color: '#111827' }}>Multi-Site Operations</h3>
//               <p style={{ color: '#6B7280' }}>Global business management in one platform</p>
//             </div>
            
//             <div className="text-center group">
//               <div className="w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" style={{ background: 'linear-gradient(to bottom right, #3B82F6, #6366F1)' }}>
//                 <Cloud className="w-10 h-10" style={{ color: '#FFFFFF' }} />
//               </div>
//               <h3 className="text-xl font-bold mb-2" style={{ color: '#111827' }}>Cloud-Enabled</h3>
//               <p style={{ color: '#6B7280' }}>Modern deployment through Infor CloudSuite</p>
//             </div>
            
//             <div className="text-center group">
//               <div className="w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" style={{ background: 'linear-gradient(to bottom right, #10B981, #14B8A6)' }}>
//                 <Zap className="w-10 h-10" style={{ color: '#FFFFFF' }} />
//               </div>
//               <h3 className="text-xl font-bold mb-2" style={{ color: '#111827' }}>Industry-Smart</h3>
//               <p style={{ color: '#6B7280' }}>Built-in functionality for complex industries</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Industry Focus Section */}
     


// <section
//   className="py-10 lg:py-10"
//   style={{
//     background: 'linear-gradient(135deg, #F8FAFC, #E0F2FE)',
//     minHeight: '100vh'
//   }}
// >
//   <div className="container mx-auto px-4">
   
//     <div className="text-center mb-8">
//       <h2
//         className="text-3xl lg:text-4xl mr-1 tracking-tight mb-6"
//         style={{ color: '#0F172A' }}
//       >
//          Industry Focus of
//         <span
//         className='text-3xl lg:text-4xl ml-1 pl-1'
//           style={{
//             background: 'linear-gradient(90deg, #FF5722, #DC2626)',
//             WebkitBackgroundClip: 'text',
//             backgroundClip: 'text',
//             color: 'transparent'
//           }}
//         >
//           Infor M3
//         </span>
//       </h2>
//       <p
//         className="text-lg lg:text-xl max-w-3xl mx-auto leading-relaxed"
//         style={{ color: '#475569' }}
//       >
//         Perfect for businesses managing high product variability, global supply chains, and complex customer demands.
//       </p>
//     </div>

//     <div className="grid lg:grid-cols-3 gap-8 mb-8">
    
//       <div className="lg:col-span-1 space-y-4">
//         {industries.map((industry, index) => (
//           <div
//             key={index}
//             className={`p-5 rounded-2xl cursor-pointer transition-all duration-300
//             }`}
//             style={{
//               backgroundColor: activeIndustry === index ? '#FFFFFF' : 'rgba(255, 255, 255, 0.85)'
//             }}
//             onClick={() => setActiveIndustry(index)}
//           >
//             <div className="flex items-center space-x-4">
//               <div
//                 className="p-4 flex items-center justify-center rounded-xl "
//                 style={{
//                   background: `linear-gradient(90deg, ${industry.color}, ${industry.color}CC)`,
//                   color: '#FFFFFF'
//                 }}
//               >
//                 {industry.icon}
//               </div>
//               <h3 className="font-bold text-lg" style={{ color: '#1E293B' }}>
//                 {industry.title}
//               </h3>
//             </div>
//           </div>
//         ))}
//       </div>

    
//       <div className="lg:col-span-2">
//         <div
//           className="rounded-3xl overflow-hidden shadow-2xl transform hover:scale-[1.01] transition-transform duration-500"
//           style={{
//             backgroundColor: industries[activeIndustry].bgColor,
//             boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
//           }}
//         >
         
//           <div className="relative">
//             <img
//               src={industries[activeIndustry].image}
//               alt={industries[activeIndustry].title}
//               className="w-full h-[350px] object-cover"
//             />
//             <div
//               className="absolute inset-0"
//               style={{
//                 background: `linear-gradient(90deg, ${industries[activeIndustry].color}E6, ${industries[activeIndustry].color}CC)`
//               }}
//             ></div>

           
//             <div className="absolute inset-0 flex items-center justify-center">
//               <div className="text-center" style={{ color: '#FFFFFF' }}>
//                 <div
//                   className="w-20 h-20 mx-auto mb-4 rounded-2xl flex items-center justify-center shadow-lg"
//                   style={{ backgroundColor: 'rgba(255,255,255,0.25)' }}
//                 >
//                   {industries[activeIndustry].icon}
//                 </div>
//                 <h3 className="text-2xl font-bold">{industries[activeIndustry].title}</h3>
//               </div>
//             </div>
//           </div>

         
//           <div className="p-8 text-center">
//             <p
//               className="text-lg leading-relaxed text-center"
//               style={{ color: '#334155' }}
//             >
//               {industries[activeIndustry].description}
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// </section>

      
   
//       {/* Services Section */}
//       <section className="py-10 px-6" style={{ background: 'linear-gradient(to bottom right, #FFFFFF, #F0FDF4)' }}>
//         <div className="container mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-3xl lg:text-4xl font-semibold mb-6 text-[#059669]" >
//               Infor M3 Services :That Drive Real Results
//             </h2>
//             <p className="text-xl max-w-3xl mx-auto text-center" style={{ color: '#6B7280' }}>
//               Comprehensive solutions designed to maximize your Infor M3 investment and accelerate business growth
//             </p>
//           </div>
          
//           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {services.map((service, index) => (
//               <div
//                 key={index}
//                 className={`group rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer transform hover:-translate-y-2 ${
//                   hoveredService === index ? 'scale-105' : ''
//                 }`}
//                 style={{ backgroundColor: '#FFFFFF' }}
//                 onMouseEnter={() => setHoveredService(index)}
//                 onMouseLeave={() => setHoveredService(null)}
//               >
//                 <div className="relative z-10">
//                   <div className="flex items-center justify-between mb-6">
//                     <div className="w-14 h-14 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300" style={{ background: `linear-gradient(to right, ${service.color}, ${service.color})`, color: '#FFFFFF' }}>
//                       {service.icon}
//                     </div>
//                     <CheckCircle className="w-6 h-6" style={{ color: '#10B981' }} />
//                   </div>
                  
//                   <h3 className="text-xl font-bold mb-4 group-hover:text-orange-600 transition-colors" style={{ color: '#111827' }}>
//                     {service.title}
//                   </h3>
                  
//                   <p className="leading-relaxed mb-6" style={{ color: '#6B7280' }}>
//                     {service.description}
//                   </p>
                  
                 
//                 </div>
                
//                 <div className="absolute inset-0 rounded-2xl transition-opacity duration-300 group-hover:opacity-5" style={{ background: `linear-gradient(to bottom right, ${service.color}, ${service.color})`, opacity: 0 }}></div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Benefits Section */}
//       <section className="py-10" style={{ background: 'linear-gradient(to bottom right, #FAF5FF, #FDF2F8)' }}>
//         <div className="container mx-auto px-4">
//           <div className="text-center mb-12">
//             <h2 className="text-4xl lg:text-5xl font-semibold mb-4" style={{ color: '#111827' }}>
//               Real-World <span className='text-4xl lg:text-5xl' style={{ background: 'linear-gradient(to right, #9333EA, #EC4899)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>Benefits</span> of Using Infor M3
//             </h2>
//             <p className="text-xl max-w-2xl mx-auto text-center" style={{ color: '#6B7280' }}>
//               Transform your business operations with proven advantages that deliver measurable results
//             </p>
//           </div>
          
//           <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
//             {benefits.map((benefit, index) => (
//               <div
//                 key={index}
//                 className={`group rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer transform hover:-translate-y-1 ${
//                   activeBenefit === index ? 'ring-2 ring-opacity-50' : ''
//                 }`}
//                 style={{
//                   backgroundColor: '#FFFFFF',
//                   ringColor: activeBenefit === index ? '#F97316' : 'transparent'
//                 }}
//                 onClick={() => setActiveBenefit(index)}
//               >
//                 <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300" style={{ background: `linear-gradient(to bottom right, ${benefit.color}, ${benefit.color})`, color: '#FFFFFF' }}>
//                   {benefit.icon}
//                 </div>
                
//                 <h3 className="text-lg font-bold mb-3 group-hover:text-orange-600 transition-colors" style={{ color: '#111827' }}>
//                   {benefit.title}
//                 </h3>
                
//                 <p className="text-sm leading-relaxed" style={{ color: '#6B7280' }}>
//                   {benefit.description}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-20 relative overflow-hidden" style={{ background: 'linear-gradient(to bottom right, #111827, #9A3412, #991B1B)' }}>
//         <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(234, 88, 12, 0.2), rgba(220, 38, 38, 0.2))' }}></div>
        
//         {/* Background animation */}
//         <div className="absolute top-0 left-0 w-full h-full">
//           <div className="absolute top-20 left-20 w-32 h-32 rounded-full blur-2xl animate-pulse" style={{ backgroundColor: 'rgba(249, 115, 22, 0.2)' }}></div>
//           <div className="absolute bottom-20 right-20 w-40 h-40 rounded-full blur-2xl animate-pulse delay-700" style={{ backgroundColor: 'rgba(220, 38, 38, 0.2)' }}></div>
//           <div className="absolute top-1/2 left-1/2 w-36 h-36 rounded-full blur-2xl animate-pulse delay-300" style={{ backgroundColor: 'rgba(245, 158, 11, 0.2)' }}></div>
//         </div>
        
//         <div className="container mx-auto px-6 relative z-10">
//           <div className="max-w-4xl mx-auto text-center">
//             <h2 className="text-3xl lg:text-4xl font-semibold mb-6" style={{ color: '#FFFFFF' }}>
//               Ready to Unlock Business <br />
//               <span   className='text-3xl lg:text-4xl'>
//                 Agility with Infor M3?
//               </span>
//             </h2>
            
//             <p className="text-xl mb-6 leading-relaxed text-center" style={{ color: '#D1D5DB' }}>
//               Join industry leaders who trust PTKCS for their Infor M3 transformation journey.
//               Let's discuss how we can drive your business growth and operational excellence.
//             </p>
            
//             <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
//               <button onClick={handleClick} className="group px-4 py-2 rounded-xl font-semibold hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 flex items-center" style={{ background: 'linear-gradient(to right, #EA580C, #DC2626)', color: '#FFFFFF', boxShadow: '0 0 50px rgba(249, 115, 22, 0.25)' }}>
//                 Start Your M3 Journey
//                 <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
//               </button>
              
             
//             </div>
            
          
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default InforM3Component;



import React, { useState } from 'react';
import { 
  ChevronRight, 
  Cloud, 
  Users, 
  Settings, 
  TrendingUp, 
  Globe, 
  BarChart3, 
  Shield, 
  Zap, 
  CheckCircle, 
  ArrowRight, 
  Play, 
  Star,
  Eye,
  DollarSign,
  Clock,
  Target,
  Gauge,
  UserCheck,
  Building,
  MapPin,
  Wifi
} from 'lucide-react';
import InforAlliancePartnerLogo from '../../../../../Assets/Logo/InforAlliancePartner.png'
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import WhyChooseus from './InforM3/WhyChoose';
import IntroHero from '../../../ResuableComponents/IntroHero';
import Intro from './InforM3/IntroCarousel';
import ImageSectionReusable from '../../../ResuableComponents/ImageSectionResuable';
import CTA from "../../../ResuableComponents/CTA"
import M3InfoGraphicImage from '../../../../../Assets/m3_infographic.png'
import M3IntroImage from '../../../../..//Assets/m3_intro.jpg'
import ConsultantIcon from '../../../../../Assets/Icons/M3/people.png'
import DevelopersIcon from '../../../../../Assets/Icons/M3/team-leader.png'
import AnalystIcon from '../../../../../Assets/Icons/M3/analytics.png'
import ModuleExpertIcon from '../../../../../Assets/Icons/M3/expert.png'
import M3CTA from './InforM3/CTA';
import M3Overview from './InforM3/M3Overview';
import M3Capabilities from './InforM3/M3Capabilities';
import M3Industries from './InforM3/M3Industries';
import M3FAQ from './InforM3/FAQ';


const InforM3StaffingComponent = () => {
  const [activeEngagement, setActiveEngagement] = useState(0);
  const [hoveredService, setHoveredService] = useState(null);
  const [activeBenefit, setActiveBenefit] = useState(0);

  const handleClick = () => {
    // Handle button click for contact
    window.scrollTo(0,0)
  }
  const engagementModels = [
    {
      title: "Onsite Staffing",
      description: "Local, embedded support for businesses needing hands-on collaboration and immediate presence.",
      icon: <Building className="w-8 h-8" />,
      color: "#F97316",
      bgColor: "#FFF7ED",
      features: ["Direct collaboration", "Immediate support", "Local presence", "Team integration"]
    },
    {
      title: "Remote Staffing",
      description: "Cost-effective delivery and offshore development with global talent accessibility.",
      icon: <Wifi className="w-8 h-8" />,
      color: "#3B82F6",
      bgColor: "#EFF6FF", 
      features: ["Cost-effective", "Global talent pool", "Flexible hours", "Scalable teams"]
    },
    {
      title: "Hybrid Models",
      description: "Balanced and scalable delivery approach combining onsite and remote advantages.",
      icon: <Globe className="w-8 h-8" />,
      color: "#10B981",
      bgColor: "#F0FDF4",
      features: ["Best of both worlds", "Scalable approach", "Optimized costs", "Flexible delivery"]
    }
  ];

  const talentTypes = [
    {
      title: "Functional Consultants",
      description: "Business process experts who understand M3 modules and can configure solutions to meet your specific requirements.",
      icon: ConsultantIcon,
      color: "#F97316"
    },
    {
      title: "Technical Developers",
      description: "Skilled developers for customizations, integrations, and technical enhancements in the M3 environment.",
      icon: DevelopersIcon,
      color: "#3B82F6"
    },
    {
      title: "System Analysts",
      description: "Experts in analyzing business requirements and translating them into effective M3 solution designs.",
      icon: AnalystIcon,
      color: "#10B981"
    },
    {
      title: "Module-Specific Experts",
      description: "Specialists in specific M3 modules like Finance, SCM, Production, Procurement, and Warehouse Management.",
      icon: ModuleExpertIcon,
      color: "#A855F7"
    }
  ];



  return (
    <>
    <Helmet>
        <title>PT KCS | Infor M3 ERP Solutions Indonesia – Manufacturing, Fashion & Distribution</title>
        <meta
          name="description"
          content="PT KCS is Indonesia's leading Infor M3 ERP partner. We deliver M3 implementation, customization, cloud migration, integration, and support for manufacturing, fashion, food & beverage, chemical, and distribution industries across Jakarta, Surabaya, and Bandung."
        />
        <meta
          name="keywords"
          content="PT KCS, PT KCS Indonesia, Infor M3 ERP Jakarta, Infor M3 implementation Indonesia, Infor M3 consulting services, Infor M3 CloudSuite Indonesia, konsultan ERP Indonesia, implementasi Infor M3, manufaktur ERP Indonesia, Infor M3 fashion apparel, Infor M3 food beverage, Infor M3 chemical pharmaceutical, Infor M3 distribution, Infor M3 staffing Indonesia, Infor M3 functional consultant, Infor M3 technical developer, Infor M3 system analyst, Infor M3 module expert, Infor M3 supply chain management, Infor M3 warehouse management, Infor M3 financial management, Infor M3 integration services, Infor M3 upgrade migration, Infor M3 support managed services, ERP provider Jakarta, ERP consulting Surabaya, ERP solutions Bandung, enterprise resource planning Indonesia, cloud ERP Indonesia, scalable ERP solutions, Infor partner Indonesia, digital transformation ERP, multi-currency ERP Indonesia, multi-site ERP, solusi ERP terbaik Indonesia"
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="PT KCS | Infor M3 ERP Solutions Indonesia" />
        <meta property="og:description" content="PT KCS delivers expert Infor M3 ERP solutions across Indonesia for manufacturing, fashion, food & beverage, chemicals, and distribution. M3 implementation, support, and staffing." />
        <meta property="og:image" content="https://www.ptkcs.com/static/media/m3_infographic.d18457778990f244f9cf.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="PT KCS | Infor M3 ERP Solutions Indonesia" />
        <meta name="twitter:description" content="PT KCS delivers expert Infor M3 ERP solutions across Indonesia for manufacturing, fashion, food & beverage, chemicals, and distribution." />
        <meta name="twitter:image" content="https://www.ptkcs.com/static/media/m3_infographic.d18457778990f244f9cf.png" />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PT KCS" />
      </Helmet>

    <div className="min-h-screen font-satoshi" style={{ backgroundColor: '#FFFFFF' }}>
      
            <Intro/>

      <M3Overview/>
      <M3Capabilities/>
      <M3Industries/>

      {/* Skilled Talent Section */}
      {/* <section className="py-16 px-6" style={{ backgroundColor: '#f5f5f5' }}>
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold mb-6" style={{ color: '#111827' }}>
              Skilled <span className='text-3xl lg:text-4xl' style={{ background: 'linear-gradient(to right, #EA580C, #DC2626)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>Infor M3 Talent</span> on Demand
            </h2>
            <p className="text-xl leading-relaxed" style={{ color: '#000000' }}>
              We provide access to a pool of experienced Infor M3 professionals, including functional consultants, technical developers, 
              system analysts, and module-specific experts. Each candidate is vetted for their hands-on experience with M3 processes 
              such as supply chain management, procurement, production, finance, and warehouse management.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {talentTypes.map((talent, index) => (
              <div 
                key={index}
                className="group rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer transform hover:-translate-y-2"
                style={{ backgroundColor: '#FFFFFF' }}
                onMouseEnter={() => setHoveredService(index)}
                onMouseLeave={() => setHoveredService(null)}
              >
                <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300" 
                     style={{ background: `linear-gradient(to right, ${talent.color}, ${talent.color})`, color: '#FFFFFF' }}>
                  <img src={talent.icon} alt="service" className='w-6 h-6'/>
                </div>
                
                <h3 className="text-lg font-bold mb-3 group-hover:text-orange-600 transition-colors" style={{ color: '#111827' }}>
                  {talent.title}
                </h3>
                
                <p className="text-sm leading-relaxed" style={{ color: '#000000' }}>
                  {talent.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Flexible Engagement Models Section */}
      {/* <section className="py-16" style={{ backgroundColor: '#ffffff', minHeight: '80vh' }}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold mb-6" style={{ color: '#0F172A' }}>
              Flexible <span className='text-3xl lg:text-4xl' style={{ background: 'linear-gradient(90deg, #FF5722, #DC2626)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>Engagement Models</span> to Fit Your Projects
            </h2>
            <p className="text-lg lg:text-xl max-w-3xl mx-auto leading-relaxed" style={{ color: '#475569' }}>
              Our staffing services are built around your project's size, duration, and complexity. From short-term consultants 
              for time-sensitive deliverables to long-term resourcing for managed services, our flexible contracts help you 
              scale up or down with ease.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8 mb-8">
            <div className="lg:col-span-1 space-y-4">
              {engagementModels.map((model, index) => (
                <div
                  key={index}
                  className="p-5 rounded-2xl cursor-pointer transition-all duration-300"
                  style={{ backgroundColor: activeEngagement === index ? '#FFFFFF' : 'rgba(255, 255, 255, 0.85)' }}
                  onClick={() => setActiveEngagement(index)}
                >
                  <div className="flex items-center space-x-4">
                    <div 
                      className="p-4 flex items-center justify-center rounded-xl" 
                      style={{ background: `linear-gradient(90deg, ${model.color}, ${model.color}CC)`, color: '#FFFFFF' }}
                    >
                      {model.icon}
                    </div>
                    <h3 className="font-bold text-lg" style={{ color: '#1E293B' }}>
                      {model.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>

            <div className="lg:col-span-2">
              <div 
                className="rounded-3xl overflow-hidden shadow-2xl transform hover:scale-[1.01] transition-transform duration-500"
                style={{ backgroundColor: engagementModels[activeEngagement].bgColor, boxShadow: '0 20px 40px rgba(0,0,0,0.1)' }}
              >
                <div className="p-8">
                  <div className="flex items-center mb-6">
                    <div 
                      className="w-16 h-16 rounded-2xl flex items-center justify-center mr-4" 
                      style={{ background: `linear-gradient(90deg, ${engagementModels[activeEngagement].color}, ${engagementModels[activeEngagement].color}CC)`, color: '#FFFFFF' }}
                    >
                      {engagementModels[activeEngagement].icon}
                    </div>
                    <h3 className="text-2xl font-bold" style={{ color: '#1E293B' }}>
                      {engagementModels[activeEngagement].title}
                    </h3>
                  </div>
                  
                  <p className="text-lg leading-relaxed mb-6" style={{ color: '#334155' }}>
                    {engagementModels[activeEngagement].description}
                  </p>
                  
                  <div className="grid grid-cols-2 gap-4">
                    {engagementModels[activeEngagement].features.map((feature, idx) => (
                      <div key={idx} className="flex items-center space-x-2">
                        <CheckCircle className="w-5 h-5" style={{ color: engagementModels[activeEngagement].color }} />
                        <span style={{ color: '#475569' }}>{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Why Choose PTKCS Section */}
      <WhyChooseus/>
      <M3FAQ/>


      {/* CTA Section */}
           <M3CTA/>
    </div>
    </>
  );
};

export default InforM3StaffingComponent;
